var exports = {
  "kL": "xfd349460--095e86--container",
  "Tp": "xfd349460--095e86--background",
  "dM": "xfd349460--095e86--background-image",
  "Qs": "xfd349460--095e86--content",
  "sw": "xfd349460--095e86--look-at-icon",
  "DD": "xfd349460--095e86--title",
};

module.exports = exports;
